$( document ).ready(function() {
  
  $('.single-slider .slide-list').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  $('.banner-lists').slick({
slidesToShow: 1,
infinite: true,
slidesToScroll: 1,
dots: false,
arrows: true,
focusOnSelect: true,
adaptiveHeight: true,
responsive: [
{
    breakpoint: 550,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]
});

  $('.product-slider .product-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
   {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 801,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.customer-slider .customer-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
});

$('.logo-slider .logo-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});  


  $(document).ready(function(){
    const marqueeLeft = document.querySelector('.marquee-left');
    if (marqueeLeft) {
      $('.marquee-left').marquee({
         direction: 'left',
         duration: 40000,
         delayBeforeStart: 0,
         duplicated: true,
         gap: 0,
         startVisible: true
       });
    }
  });

});


